var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ability',{on:{"on-more-person":_vm.handleChangePerson}}),_c('message',{attrs:{"showMorePerson":_vm.showMorePerson}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }